export default __webpack_public_path__ + "37b4f298b67de1337e34a0bbae29f8b5.svg";